import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  LernfeldContentGroup,
  LernfeldContentLine,
  Occupation,
} from '../models/lernfeld-content.model';

@Injectable({ providedIn: 'root' })
export class LernfeldContentService {
  private http = inject(HttpClient);
  private apiUrl = environment.apiUrl + '/lernfeld-content';

  getAll(): Observable<LernfeldContentGroup[]> {
    return this.http.get<LernfeldContentGroup[]>(this.apiUrl);
  }

  getOccupations(): Observable<Occupation[]> {
    return this.http.get<Occupation[]>(`${this.apiUrl}/occupations`);
  }

  createOccupation(occupation: Partial<Occupation>): Observable<Occupation> {
    return this.http.post<Occupation>(`${this.apiUrl}/occupations`, occupation);
  }

  updateOccupation(
    id: number,
    occupation: Partial<Occupation>,
  ): Observable<Occupation> {
    return this.http.put<Occupation>(
      `${this.apiUrl}/occupations/${id}`,
      occupation,
    );
  }

  // Löscht den Ausbildungsberuf samt aller Lernfelder und Inhalte.
  deleteOccupation(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/occupations/${id}`);
  }

  createGroup(
    group: Partial<LernfeldContentGroup>,
  ): Observable<LernfeldContentGroup> {
    return this.http.post<LernfeldContentGroup>(`${this.apiUrl}/groups`, group);
  }

  updateGroup(
    id: number,
    group: Partial<LernfeldContentGroup>,
  ): Observable<LernfeldContentGroup> {
    return this.http.put<LernfeldContentGroup>(
      `${this.apiUrl}/groups/${id}`,
      group,
    );
  }

  deleteGroup(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/groups/${id}`);
  }

  createLine(
    line: Partial<LernfeldContentLine>,
  ): Observable<LernfeldContentLine> {
    return this.http.post<LernfeldContentLine>(`${this.apiUrl}/lines`, line);
  }

  updateLine(
    id: number,
    line: Partial<LernfeldContentLine>,
  ): Observable<LernfeldContentLine> {
    return this.http.put<LernfeldContentLine>(
      `${this.apiUrl}/lines/${id}`,
      line,
    );
  }

  deleteLine(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/lines/${id}`);
  }
}
